; (function ($) {

    'use strict';

    $(document).ready(function () {

        $('.form.form-contact').each(function () {

            $(this).on('submit.validate', 'form.validate', function (e) {
                e.preventDefault();
                var $form = $(this);
                if ($form.validate({
                    fields: $form.find('input.validate, select.validate, textarea.validate')
                }, function (validated) {
                    validated && $(document).off('submit.validate') && $form.submit();
                }));
            });

            $(this).on('click', 'input.validate[type=checkbox]', function (event) { //, input.validate[type=radio]
                var $input = $(this);
                var $siblings = $input.closest('form').find('input[name=' + $input.attr('name') + ']');
                $siblings.closest('label').removeClass('selected');
                $siblings.filter(':checked').each(function () {
                    $(this).closest('label').addClass('selected');
                });
                $(this).closest('form').validate({
                    fields: this
                });
            });

            $(this).on('blur', 'input.validate:not([type=checkbox]), select.validate, textarea.validate', function (e) { //, [type=radio]

                $(this).closest('form').validate({ fields: this });
                if (
                    e.relatedTarget
                    && e.relatedTarget.type == "button"
                ) {
                    var validate = $(e.relatedTarget).data('validate');
                    console.log('blurvalidate:' + validate);

                    var email_cl = $('#field-email').val();
                    var phone_number_cl = $('#field-phone').val();
                    phone_number_cl = phone_number_cl.replace("+33", "0");
                    console.log('blur/contact/step--' + email_cl);

                    if (validate) {
                        var $form = $(e.relatedTarget).closest('form');
                        var $tab = $(e.relatedTarget).closest('.tab');
                        var step = 2;
                        console.log($form[0]);




                        $form.validate({ fields: $tab.find('.validate'), data: { step: step } }, function (validated, response) {
                            if (response.success && response.message) {

                                const formData = new FormData($form[0]);
                                console.log(formData);

                                $form.empty();

                                var nbSteps = parseInt($form.closest('.stepper').find('.steps').data('nbSteps'));
                                if (2 === nbSteps) {
                                    $('<div class="feedback success">').html(response.message).insertBefore($form);
                                }

                                // }
                                validated && step;


                                console.log('/contact/2step-' + step);
                                console.log(formData);
                                // if (step == 3) {
                                var url_page = $(location).attr('href');
                                var tab_url_page = url_page.split("coursparticuliers.com");
                                // var tab_url_page = url_page.split("main.abccours.greentic.net");
                                if (tab_url_page[1] == "/nous-contacter") {
                                    var form_id_val = "form-contact";
                                } else if (tab_url_page[1] == "" || tab_url_page[1] == "/") {
                                    var form_id_val = "form-contact-bottom";
                                } else {
                                    var form_id_val = "form-contact-bottom"; //le popin n'existe pas
                                }


                                dataLayer.push({
                                    'event': 'cf7submission',
                                    'valeur_prospect': 150, // Moyenne
                                    'form_id': form_id_val,
                                    'email': email_cl,
                                    'phone_number': phone_number_cl
                                });

                                var tagCalendar = $('#tag-calendar').html();
                                $form.append(tagCalendar);


                                var calendlyWidget = document.querySelector('.calendly-inline-widget');
                                calendlyInitInlineWidgetCall(calendlyWidget, $form, formData);

                                $('#entete_contact').html('');
                                $('.container container-page').scroll();


                            }
                        });
                    } else {
                        console.log('no validated2');
                    }

                }
            });



            $(this).on('click', 'button', function (event) {
                event.preventDefault();
                var validate = $(this).data('validate');

                console.log('validate:' + validate);
                var email_cl = $('#field-email').val();
                var phone_number_cl = $('#field-phone').val();
                phone_number_cl = phone_number_cl.replace("+33", "0");
                console.log('click/contact/step-' + email_cl);

                //$('#field-zip-code').blur();



                if (validate) {
                    var $form = $(this).closest('form');
                    var $tab = $(this).closest('.tab');
                    var step = 2;
                    console.log('validate ok');
                    $form.validate({
                        fields: $tab.find('.validate'),
                        data: {
                            step: step
                        }
                    }, function (validated, response) {
                        if (response.success && response.message) {

                            console.log('validate okok');

                            const formData = new FormData($form[0]);

                            /*
                            $form.empty().append(
                                $('<div class="feedback success">').html(response.message)
                            );
                            */
                            $form.empty();

                            var nbSteps = parseInt($form.closest('.stepper').find('.steps').data('nbSteps'));

                            if (2 === nbSteps) {
                                $('<div class="feedback success">').html(response.message).insertBefore($form);
                            }


                            //}
                            validated && step;
                            // //commenté le 30-01-24 && ga && ga('send', 'pageview', '/contact/step-' + step);


                            console.log('/contact/1step-' + step);
                            console.log(formData);
                            // if (step == 3) {
                            var url_page = $(location).attr('href');
                            var tab_url_page = url_page.split("coursparticuliers.com");
                            //var tab_url_page = url_page.split("main.abccours.greentic.net");

                            if (tab_url_page[1] == "/nous-contacter") {
                                var form_id_val = "form-contact";
                            } else if (tab_url_page[1] == "" || tab_url_page[1] == "/") {
                                var form_id_val = "form-contact-bottom";
                            } else {
                                var form_id_val = "form-contact-bottom"; //le popin n'existe pas
                            }



                            dataLayer.push({
                                'event': 'cf7submission',
                                'valeur_prospect': 150, // Moyenne
                                'form_id': form_id_val,
                                'email': email_cl,
                                'phone_number': phone_number_cl
                            });

                            var tagCalendar = $('#tag-calendar').html();
                            $form.append(tagCalendar);
                            console.log('calendlyWidget');
                            var calendlyWidget = document.querySelector('.calendly-inline-widget');
                            calendlyInitInlineWidgetCall(calendlyWidget, $form, formData);
                            console.log('fin calendlyWidget');

                            $('#entete_contact').html('');
                            $('.container container-page').scroll();


                        } else {
                            console.log('no success:');
                            console.dir(response);
                        }


                    });
                } else {
                    console.log('no validated-click');

                }
            });



            $('#field-subject').on('change', function (event) {
                $('#field-subject-language')
                    .closest('.form-conditionnal')
                    .toggle($(this).val() == 'Langues vivantes')
                    .find('input, select, textarea').prop('disabled', $(this).val() != 'Langues vivantes');
                $('#field-subject-exam')
                    .closest('.form-conditionnal')
                    .toggle($(this).val() == 'Préparation à un examen')
                    .find('input, select, textarea').prop('disabled', $(this).val() != 'Préparation à un examen');
                $('#field-subject-other')
                    .closest('.form-conditionnal')
                    .toggle($(this).val() == 'Autres')
                    .find('input, select, textarea').prop('disabled', $(this).val() != 'Autres');
            });
            $('#field-subject-language').on('change', function (event) {
                $('#field-subject-language-other')
                    .closest('.form-conditionnal')
                    .toggle($(this).val() == 'Autres')
                    .find('input, select, textarea').prop('disabled', $(this).val() != 'Autres');
            });
            $('#field-subject-exam').on('change', function (event) {
                $('#field-subject-exam-other')
                    .closest('.form-conditionnal')
                    .toggle($(this).val() == 'Autres')
                    .find('input, select, textarea').prop('disabled', $(this).val() != 'Autres');
            });

            $(".submit-button").on("click", function (e) {
                const finalStep = document.querySelector('.final-step');
                const checkboxChecked = finalStep.querySelector('.rgpd-checkbox').checked;
                /*
                if (checkboxChecked) {
                    finalStep.classList.add('final-step-loading');
                }
                */
            })

        });

    });

})(jQuery);

function isCalendlyEvent(e) {
    return e.origin === "https://calendly.com" && e.data.event && e.data.event.indexOf("calendly.") === 0;
};

window.addEventListener("message", function (e) {
    if (isCalendlyEvent(e)) {
        if ('calendly.date_and_time_selected' === e.data.event && jQuery('.feedback.success').is(':visible')) {
            jQuery('.feedback.success').slideUp();
        }

        if ('calendly.event_scheduled' === e.data.event) {
            let $forms = jQuery('.form-contact.stepper');
            let $formVisible = $forms.filter(function () {
                return jQuery(this).is(':visible');
            }).first();

            if ($formVisible.length) {
                let formContainer = $formVisible;

                // Dernière étape
                let totalSteps = parseInt(formContainer.find('.steps').attr('data-nb-steps'));
                formContainer.attr('data-current-step', totalSteps);

                if (jQuery('dialog.single-formation-modal-contact').is(':visible')) {
                    jQuery('dialog.single-formation-modal-contact').animate({
                        scrollTop: jQuery('dialog.single-formation-modal-contact').scrollTop() + (jQuery('.form.form-generic.form-contact.stepper').offset().top - jQuery('.form.form-generic.form-contact.stepper .steps').height())
                    }, 500);
                } else {
                    jQuery('html, body').animate({
                        scrollTop: formContainer.find('.steps').offset().top - 10
                    }, 500);
                }
            }
        }
    }
});

function calendlyInitInlineWidgetCall(calendlyWidget, form, formData) {

    console.log(formData);

    let formDataEntries = Object.fromEntries(formData.entries());
    let calendlyWidgetPrefill = {
        name: formDataEntries['firstname'] + ' ' + formDataEntries['lastname'],
        email: formDataEntries['email'],
        customAnswers: {
            a1: formDataEntries['phone'],
            a2: formDataEntries['zip-code'],
        }
    };

    console.log(formDataEntries['firstname']);


    jQuery.getScript('https://assets.calendly.com/assets/external/widget.js', function () {

        let widget = calendlyWidget;
        let url = new URL(widget.dataset.url);
        ['hide_gdpr_banner'].forEach(param => {
            if (!url.searchParams.has(param)) url.searchParams.set(param, '1');
        });

        let calendlyWidgetUrl = url.toString();

        Calendly.initInlineWidget({
            url: calendlyWidgetUrl,
            parentElement: calendlyWidget,
            prefill: calendlyWidgetPrefill
        });

        // On mets à jour l'étape actuelle
        let formContainer = form.closest('.stepper');
        let currentStep = parseInt(formContainer.data('current-step'));

        formContainer.attr('data-current-step', currentStep + 1);

        if (jQuery('dialog.single-formation-modal-contact').is(':visible')) {
            jQuery('dialog.single-formation-modal-contact').animate({
                scrollTop: jQuery('dialog.single-formation-modal-contact').scrollTop() + (jQuery('.form.form-generic.form-contact.stepper').offset().top - jQuery('.form.form-generic.form-contact.stepper .steps').height())
            }, 500);
        } else {
            jQuery('html, body').animate({
                scrollTop: formContainer.find('.steps').offset().top - 10
            }, 500);
        }
    });
}